// utils/deriveLatestRun.js
export const LatestRunOrder = [
  'manual', // manual run requested (Active + LatestRun)
  'success', // completed, no warnings
  'success_warnings', // completed, with warnings
  'failed', // failed (Active or Inactive)
  'inactive_run', // inactive + has LatestRun
  'inactive_no_run', // inactive + no LatestRun
  'no_output', // completed but no processable output / default fallback
];

export function deriveLatestRunMeta(row) {
  const isActive = row?.StateCode === 'Active';
  const hasManualRun = !!row?.LatestRun;
  const latest = row?.LatestJobRun;
  const statusStr = latest?.Status;
  const warnings = latest?.Output?.warnings ?? [];
  const errors = latest?.Output?.errors ?? [];

  if (isActive && hasManualRun) return { status: 'manual', warnings, errors };

  if (!isActive && hasManualRun)
    return { status: 'inactive_run', warnings, errors };
  if (!isActive && !hasManualRun && statusStr === 'Failed')
    return { status: 'failed', warnings, errors };
  if (!isActive && !hasManualRun)
    return { status: 'inactive_no_run', warnings, errors };

  if (
    isActive &&
    !hasManualRun &&
    statusStr === 'SuccessfullyCompleted' &&
    warnings.length === 0
  )
    return { status: 'success', warnings, errors };

  if (
    isActive &&
    !hasManualRun &&
    statusStr === 'SuccessfullyCompleted' &&
    warnings.length > 0
  )
    return { status: 'success_warnings', warnings, errors };

  if (isActive && !hasManualRun && statusStr === 'Failed')
    return { status: 'failed', warnings, errors };

  return { status: 'no_output', warnings, errors };
}
